var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("Scaffold:")]),_c('ProteinLoader',{attrs:{"example-act":"scaffold-edit","role":"scaffold"}}),_c('div',[_vm._v("Insert:")]),_c('ProteinLoader',{attrs:{"role":"insert"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }